import { post } from '../Services/http';
import { trackFormSubmit } from '../Tracking';
import { pushEvent } from '../Tracking/dataLayer';

(function () {
  const forms = document.querySelectorAll('form.become-customer-form');
  if (!forms.length) return;

  forms.forEach((form) => {
    const input = form.querySelector('input[name="email"]');
    const submit = form.querySelector('button[type="submit"]');
    const messageEl = form.querySelector('.become-customer-form__message');
    const errorEl = form.querySelector('.become-customer-form__error');

    if (!input || !submit || !messageEl || !errorEl) return;

    const showMessage = (el, text) => {
      el.textContent = text;
      el.classList.remove('hidden');
    };
    const hideMessages = () => {
      messageEl.classList.add('hidden');
      errorEl.classList.add('hidden');
      messageEl.textContent = '';
      errorEl.textContent = '';
    };

    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const email = (input.value || '').trim();
      if (!email) {
        input.focus();
        return;
      }

      hideMessages();
      submit.disabled = true;

      try {
        const response = await post('/api/become-customer', { email });
        const data = await response.json();
        if (data && data.success) {
          trackFormSubmit('become_customer');
          pushEvent('sign_up', { method: 'become_customer' });
          showMessage(messageEl, (data && data.message) || '');
          input.value = '';
        } else {
          showMessage(errorEl, (data && data.message) || '');
        }
      } catch (err) {
        let message = '';
        try {
          const data = await err.response.json();
          message = (data && data.message) || '';
        } catch (_) {}
        showMessage(errorEl, message);
      } finally {
        submit.disabled = false;
      }
    });
  });
})();
